import styled from 'styled-components'
import { Button, contentColorStyle } from './button'
import { textWeightStyles } from '../text/textStyles'

export const PopoverButton = styled(Button)`
    background-color: transparent;
    border: unset;
    border-radius: 0px;

    ${(p) => contentColorStyle(p.theme.colors.tertiary.tertiary900)}

    > div {
        justify-content: left;
        ${textWeightStyles['paragraph']}
    }

    &:hover {
        border: unset;
        background-color: ${(p) => p.theme.colors.tertiary.tertiary100};
    }

    &:active {
        border: unset;
        background-color: ${(p) => p.theme.colors.tertiary.tertiary200};
    }
`
